import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import HomePage from './pages/HomePage';
import EvenementPage from './pages/EvenementPage';
import ContactPage from './pages/ContactPage';
import InscriptionPage from './pages/InscriptionPage';
import MentionsLegalesPage from './pages/MentionsLegalesPage';
import NotFoundPage from './pages/NotFoundPage';

// Members area
import { AuthProvider } from './members/AuthContext';
import MembersNavbar from './members/components/MembersNavbar';
import ProtectedRoute from './members/ProtectedRoute';
import LoginPage from './members/pages/LoginPage';
import CheckEmailPage from './members/pages/CheckEmailPage';
import VerifyPage from './members/pages/VerifyPage';
import DashboardPage from './members/pages/DashboardPage';
import EditionsPage from './members/pages/EditionsPage';
import EditionDetailPage from './members/pages/EditionDetailPage';
import DirectoryPage from './members/pages/DirectoryPage';

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      // Wait for DOM to render, then scroll to the anchor
      setTimeout(() => {
        const el = document.getElementById(hash.replace('#', ''));
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}

function useScrollAnimations() {
  const location = useLocation();
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    // Small delay to let the DOM render
    const timer = setTimeout(() => {
      const elements = document.querySelectorAll('.fade-in, .slide-up');
      elements.forEach((el) => observer.observe(el));
    }, 100);

    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, [location.pathname]);
}

function MembersLayout({ children }) {
  return (
    <div className="App">
      <MembersNavbar />
      {children}
    </div>
  );
}

function App() {
  useScrollAnimations();

  return (
    <AuthProvider>
      <div className="App">
        <ScrollToTop />
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<><Navbar /><HomePage /><Footer /></>} />
          <Route path="/evenement" element={<><Navbar /><EvenementPage /><Footer /></>} />
          <Route path="/nous-contacter" element={<><Navbar /><ContactPage /><Footer /></>} />
          <Route path="/inscription" element={<><Navbar /><InscriptionPage /><Footer /></>} />
          <Route path="/mentions-legales" element={<><Navbar /><MentionsLegalesPage /><Footer /></>} />

          {/* Members routes */}
          <Route path="/members" element={<MembersLayout><LoginPage /></MembersLayout>} />
          <Route path="/members/check-email" element={<MembersLayout><CheckEmailPage /></MembersLayout>} />
          <Route path="/members/verify" element={<MembersLayout><VerifyPage /></MembersLayout>} />
          <Route
            path="/members/dashboard"
            element={
              <MembersLayout>
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              </MembersLayout>
            }
          />
          <Route
            path="/members/editions"
            element={
              <MembersLayout>
                <ProtectedRoute>
                  <EditionsPage />
                </ProtectedRoute>
              </MembersLayout>
            }
          />
          <Route
            path="/members/editions/:id"
            element={
              <MembersLayout>
                <ProtectedRoute>
                  <EditionDetailPage />
                </ProtectedRoute>
              </MembersLayout>
            }
          />
          <Route
            path="/members/directory"
            element={
              <MembersLayout>
                <ProtectedRoute>
                  <DirectoryPage />
                </ProtectedRoute>
              </MembersLayout>
            }
          />

          {/* 404 */}
          <Route path="*" element={<><Navbar /><NotFoundPage /></>} />
        </Routes>
        <CookieConsent />
      </div>
    </AuthProvider>
  );
}

export default App;
